import { Guardian } from '@xaamin/guardian';

Guardian.define('socios.negocio.crear', (user) => {
  return user.can('socios.negocio.crear');
});

Guardian.define('socios.negocio.listar', (user) => {
  return user.can('socios.negocio.listar');
});

Guardian.define('socios.negocio.info', (user) => {
  return user.can('socios.negocio.info');
});

Guardian.define('socios.negocio.editar', (user) => {
  return user.can('socios.negocio.editar');
});

Guardian.define('socios.negocio.activar', (user) => {
  return user.can('socios.negocio.activar');
});

Guardian.define('socios.negocio.suspender', (user) => {
  return user.can('socios.negocio.suspender');
});

Guardian.define('socios.negocio.reenviar.invitacion', (user) => {
  return user.can('socios.negocio.reenviar.invitacion');
});